import fr from "./fr";
import en from "./en";

export { fr, en };

export default { fr, en };
